import { createSlice } from "@reduxjs/toolkit";
import {
  getFortalezaStartThunk,
  getFortalezaCurrentThunk,
  sendFortalezaAnswerThunk,
  getFortalezaStatusThunk,
  getFortalezasCompletadasThunk,
  getFortalezaSummaryThunk,
} from "./fortalezaTalentos.thunks";

const initialState = {
  // Estado de las fortalezas
  status: null, // { todas_completadas: false, talento_nombre: "..." }

  // Área actual con sus acciones
  currentArea: null,
  // Estructura esperada:
  // {
  //   todas_completadas: false,
  //   total_areas: 4,
  //   talento: "Liderazgo",
  //   area: { id, area, acciones: [{id, frase}] },
  //   progreso: 1,
  //   es_ultima: false
  // }

  // Fortalezas completadas
  fortalezas: [],

  // Resumen final
  summary: null,

  // Acciones seleccionadas en el área actual
  selectedAcciones: [],

  // Estados de carga
  loading: false,
  statusLoading: false,
  fortalezasLoading: false,
  summaryLoading: false,

  // Error
  error: null,
};

const fortalezaTalentosSlice = createSlice({
  name: "fortalezaTalentos",
  initialState,
  reducers: {
    toggleAccion: (state, action) => {
      const accionId = action.payload;
      const index = state.selectedAcciones.indexOf(accionId);

      if (index > -1) {
        // Si ya está seleccionada, la quitamos
        state.selectedAcciones.splice(index, 1);
      } else {
        // Si no está, la agregamos
        state.selectedAcciones.push(accionId);
      }
    },
    clearSelectedAcciones: (state) => {
      state.selectedAcciones = [];
    },
    resetFortalezaTalentosState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // GET START
      .addCase(getFortalezaStartThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFortalezaStartThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action.payload;
      })
      .addCase(getFortalezaStartThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET CURRENT AREA
      .addCase(getFortalezaCurrentThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFortalezaCurrentThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.currentArea = action.payload;
        // Limpiar selección al cambiar de área
        state.selectedAcciones = [];
      })
      .addCase(getFortalezaCurrentThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // SEND ANSWER
      .addCase(sendFortalezaAnswerThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendFortalezaAnswerThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.completado) {
          state.currentArea = null;
        } else {
          state.currentArea = action.payload;
          state.selectedAcciones = [];
        }
      })
      .addCase(sendFortalezaAnswerThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET STATUS
      .addCase(getFortalezaStatusThunk.pending, (state) => {
        state.statusLoading = true;
        state.error = null;
      })
      .addCase(getFortalezaStatusThunk.fulfilled, (state, action) => {
        state.statusLoading = false;
        state.status = action.payload;
      })
      .addCase(getFortalezaStatusThunk.rejected, (state, action) => {
        state.statusLoading = false;
        state.error = action.payload;
      })

      // GET COMPLETADAS
      .addCase(getFortalezasCompletadasThunk.pending, (state) => {
        state.fortalezasLoading = true;
        state.error = null;
      })
      .addCase(getFortalezasCompletadasThunk.fulfilled, (state, action) => {
        state.fortalezasLoading = false;
        state.fortalezas = action.payload.fortalezas || [];
      })
      .addCase(getFortalezasCompletadasThunk.rejected, (state, action) => {
        state.fortalezasLoading = false;
        state.error = action.payload;
      })

      // GET SUMMARY
      .addCase(getFortalezaSummaryThunk.pending, (state) => {
        state.summaryLoading = true;
        state.error = null;
      })
      .addCase(getFortalezaSummaryThunk.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.summary = action.payload;
      })
      .addCase(getFortalezaSummaryThunk.rejected, (state, action) => {
        state.summaryLoading = false;
        state.error = action.payload;
      });
  },
});

export const {
  toggleAccion,
  clearSelectedAcciones,
  resetFortalezaTalentosState,
} = fortalezaTalentosSlice.actions;

export default fortalezaTalentosSlice.reducer;
